module.exports = __webpack_public_path__ + "static/img/failed.b3469a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/failed.png
// module id = FuVk
// module chunks = 134